import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../state/language";
import { Button } from "../components/Button";
import { resetContent } from "../db/seed";
import { isDebugEnabled, setDebugEnabled } from "../lib/debug";

export default function Settings() {
  const nav = useNavigate();
  const { t } = useLanguage();
  const [resetMsg, setResetMsg] = useState<string | null>(null);
  const [debug, setDebug] = useState<boolean>(() => isDebugEnabled());

  return (
    <div className="pp-screen px-5">
      <header className="flex items-center justify-between pt-4">
        <Button variant="ghost" size="sm" onClick={() => nav(-1)}>
          ← {t("cta_back")}
        </Button>
        <h2 className="font-display text-xl font-bold">{t("settings_title")}</h2>
        <div className="w-12" />
      </header>

      <section className="mt-8 flex flex-col gap-3">
        <Button
          variant="ghost"
          fullWidth
          onClick={async () => {
            await resetContent();
            setResetMsg(t("settings_reset_content_done"));
            setTimeout(() => setResetMsg(null), 2000);
          }}
        >
          {t("settings_reset_content")}
        </Button>
        {resetMsg && <div className="text-emerald-300 text-center text-sm">{resetMsg}</div>}
        <Button variant="outline" fullWidth onClick={() => nav("/admin")}>
          {t("settings_admin")}
        </Button>

        <label className="flex items-center justify-between gap-3 rounded-lg bg-white/5 border border-white/10 px-4 py-3 cursor-pointer">
          <div className="flex flex-col">
            <span className="text-sm font-bold">🛠 Дебаг: показати ID карток</span>
            <span className="text-[11px] opacity-60">
              На картках і консеквенціях буде видно ID — для скріншотів і виправлень
            </span>
          </div>
          <input
            type="checkbox"
            checked={debug}
            onChange={(e) => {
              setDebug(e.target.checked);
              setDebugEnabled(e.target.checked);
            }}
            className="w-5 h-5 cursor-pointer"
          />
        </label>
      </section>

      <div className="flex-1" />
      <div className="pt-6 pb-2 text-center text-xs opacity-50">
        Portal Party · v0.1.0
      </div>
    </div>
  );
}
